<template>
	<v-container fluid class="pb-2">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat outlined class="pb-0 pt-0">
					<v-card-text class="pb-0 pt-2">
						<v-row>
							<v-col class="pb-0 pt-0">
								<v-card-title class="d-flex justify-left align-center pa-2 pb-0">
									{{ $t('titles.candidates') }}</v-card-title
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pt-0">
								<TheTable
									:additional-filters="surveyCandidatesTable.additionalFilters"
									:default-sort="surveyCandidatesTable.defaultSort"
									:excel="false"
									:fields="surveyCandidatesTable.headers"
									:header-selection-key="'survey-candidates-headers'"
									:height="surveyCandidatesTable.height"
									:total-records="surveyCandidatesTable.total"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in surveyCandidatesTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="openSurvey(props.item.id, true)"
									>
										<td
											v-if="surveyCandidatesTable.selectedHeaders.includes('rbr')"
											@click="openSurvey(item.id, item.completed)"
										>
											{{
												item.candidate_id != null
													? $t('fields.candidate') + ' ' + item.ordinal_number
													: $t('labels.manualInsert')
											}}
										</td>
										<td
											v-if="surveyCandidatesTable.selectedHeaders.includes('date')"
											@click="openSurvey(item.id, item.completed)"
										>
											{{ item.date }}
										</td>

										<td
											v-if="surveyCandidatesTable.selectedHeaders.includes('survey_completed')"
											@click="openSurvey(item.id, item.completed)"
										>
											<v-icon v-if="item.completed" small>fa-check</v-icon>
											<v-icon v-else small>fa-xmark</v-icon>
										</td>
										<td
											v-if="
												surveyCandidatesTable.selectedHeaders.includes('ratings_explainations')
											"
											@click="openSurvey(item.id, item.completed)"
										>
											{{ item.ratings_explainations }}
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
				<v-row v-if="showModal">
					<v-col>
						<Modal :show-modal="showModal">
							<template v-slot:title>
								<v-row class="d-flex justify-space-between">
									<v-col></v-col>
									<v-col class="d-flex justify-center">
										<div :class="['text-h6', 'pa-2']">
											{{ $t('titles.survey') }}
										</div>
									</v-col>
									<v-col class="d-flex justify-end">
										<div :class="['text-body-2', 'pt-2', 'pb-0']">
											{{ $t('labels.obSurveyNumber') }}
										</div>
									</v-col>
								</v-row>
							</template>
							<Survey
								@close="closeModal"
								:inEditMode="false"
								:candidateSurveyId="candidateSurveyId"
							></Survey>
						</Modal>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Modal from '../../trinkets/Modal';
import Survey from './Survey';

export default {
	name: 'SurveyCandidates',
	components: { TheTable, Modal, Survey },
	data: function () {
		return {
			surveyCandidatesTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.type'),
						value: 'rbr',
						type: '',
						sortable: false,
						width: '50px',
						allowFilter: false,
					},
					{
						text: this.$t('fields.date'),
						value: 'date',
						type: '',
						sortable: false,
						width: '70px',
						allowFilter: true,
					},
					{
						text: this.$t('fields.surveyCompleted'),
						value: 'survey_completed',
						type: '',
						width: '50px',
						sortable: false,
						allowFilter: false,
					},
					{
						text: this.$t('fields.ratingsExplaination'),
						value: 'ratings_explainations',
						type: '',
						sortable: false,
						width: '50px',
						allowFilter: true,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
			candidateSurveyId: null,
			showModal: false,
		};
	},
	methods: {
		openSurvey(id, completed) {
			if (completed) {
				this.showModal = true;
				this.candidateSurveyId = id;
			}
		},
		closeModal() {
			this.showModal = false;
			this.candidateSurveyId = null;
		},
		selectHeaders(headers) {
			this.surveyCandidatesTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.surveyCandidatesTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'planned-course-surveys/' + this.$route.params.id,
				request,
				(data, success) => {
					if (success) {
						vm.surveyCandidatesTable.items = data.items;
						vm.surveyCandidatesTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.surveyCandidatesTable.height = window.innerHeight - 390 + 'px';
		},
	},
	mounted() {
		let vm = this;
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$modalBus.$on('reloadSurveyCandidates', () => {
			vm.reloadData(vm.surveyCandidatesTable.lastRequest);
		});

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
